import {LoggingController} from "./route/loggingController";
import {DirectMailerLogsControllerName} from "../utils/names/controllerNames";
import DirectMailerLogsModuleConfiguration from "./DirectMailerLogsModuleConfiguration";
import {DirectMailerLog} from "./component/direct_mailer_log/DirectMailerLog";
import {DirectMailerLogsServiceName} from "../utils/names/serviceNames";
import {DirectMailerLogsService} from "./service/DirectMailerLogsService";
import {DirectMailerFilter} from "./component/direct_mailer_filter/DirectMailerFilter";

DirectMailerLogsModuleConfiguration
    .createNewModule()
    .controller(DirectMailerLogsControllerName, LoggingController.instance)
    .service(DirectMailerLogsServiceName, DirectMailerLogsService.instance)
    .component("directMailerLog", DirectMailerLog.instance)
    .component("directMailerFilter", DirectMailerFilter.instance);